import { DateTime } from 'luxon'

export function formatForServer(
    date: DateTime,
): string {
    return date.set({ millisecond: 0 }).toUTC().toISO({ suppressMilliseconds: true })
}